// Shared document status meta: one source of truth for HQ (dark) + client workspace (light).
export const DOC_STATUS_META = {
  draft: {
    label: "Draft",
    light: "bg-[#f2f2f0] text-[#6b6b6b] border-[#e4e4e2]",
    dark: "bg-white/[0.08] text-white/50 border-white/15",
  },
  shared: {
    label: "Shared",
    light: "bg-[#eef2f9] text-[#2e4266] border-[#d7e0ef]",
    dark: "bg-sky-300/10 text-sky-200 border-sky-300/25",
  },
  approved: {
    label: "Approved",
    light: "bg-[#ecf7ef] text-[#1c7c3c] border-[#d3ecd9]",
    dark: "bg-emerald-300/10 text-emerald-200 border-emerald-300/25",
  },
  needs_changes: {
    label: "Needs Changes",
    light: "bg-[#fdf3e4] text-[#9a6b1f] border-[#f3e2c2]",
    dark: "bg-amber-300/10 text-amber-200 border-amber-300/25",
  },
  final: {
    label: "Final",
    light: "bg-[#0a0a0a] text-white border-[#0a0a0a]",
    dark: "bg-white text-[#0c111c] border-white",
  },
};

export const docStatusMeta = (s) => DOC_STATUS_META[s] || DOC_STATUS_META.shared;

export const fmtDocDate = (iso) =>
  iso
    ? new Date(iso).toLocaleString(undefined, {
        day: "numeric", month: "short", hour: "2-digit", minute: "2-digit",
      })
    : "";
